/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let ShapeCircle = class ShapeCircle extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createCircle(shape.radius);
        geometry.translate(shape.cx, shape.cy, 0);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide, depthWrite: false });
        this.addOutline(geometry, decoration);
    }
    format() {
        /*    const {source, t, s} = this.transformPose<ShapeCircleDesc>();
        
            return {
              radius: s.x * source.radius, // x and y should be equal
              cx: source.cx + t.x,
              cy: source.cy + t.y,
            };
            */
        return undefined;
    }
};
ShapeCircle = tslib_1.__decorate([
    Shape('Shape.Circle'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], ShapeCircle);
export { ShapeCircle };
//# sourceMappingURL=ShapeCircle.js.map